import React,{useEffect} from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NavigationMenu from '../NavigationMenu';
import { useNavigate } from 'react-router-dom';
import Footer from './../common/Footer';
function SurveyThankyou(props) {
  const navigate=useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0);
        }, []);
    return(
        <Box sx={{ display: 'flex' }}>  
            <NavigationMenu pageName={"Dashboard"}/>

      <Box className="pageContainer2">
      <Box width='100%' className="bg-dashboard-image" minHeight='760px'> 

          <Box width='100%' sx={{ paddingRight:'20px'}}>
            <Box className="text-Section">

              <Typography sx={{fontWeight:'500', fontSize:'35px', textTransform: 'uppercase', fontFamily: 'Quicksand',textAlign:'center',lineHeight:'1.4 !important', paddingTop:'240px'}}>THANK YOU For completing the 10 elements of YOUR Wellbeing Wheel</Typography>

            </Box>
            </Box>

                  <Box
                  width='100%'
                  display='flex'
                  justifyContent='center'
                  sx={{paddingTop:'30px', paddingBottom:'30px'}}
                  >
                    <Box component="img"
                    justifyContent='center'
                          sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                          alt="Org Image"
                          src={process.env.PUBLIC_URL + "/images/view-my-score-button.png"}
                          onClick={()=>{
                            navigate("/scoreresult");
                            }}
                      />
          </Box></Box>
      <Footer />
        </Box>
        </Box>
    );
}
export default SurveyThankyou;